import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  EventEmitter,
  Input,
  Output,
  forwardRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR  } from '@angular/forms';
import { ClmtlkService } from 'app/clmtlk/shared/service/clmtlk.service';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'clmtlk-message-editor',
  template: '<textarea id="{{elementId}}" class="form-control"></textarea>',
  // templateUrl: './message-editor.component.html',
  styleUrls: ['./message-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MessageEditorComponent),
      multi: true
    }],
})
export class MessageEditorComponent implements OnInit, AfterViewInit, OnDestroy, ControlValueAccessor {


  @Input() elementId: string;
  messageContent: string;
  editor: any;
  streamUserSignature: string;
  onModelChange: Function = (_: any) => { };
  onModelTouch: Function = (_: any) => { };

  constructor(private clmtlkService: ClmtlkService,
              private clmtlkSessionService: ClmtlkSessionService,
              private toastrService: ToastrService) { }




  ngOnInit() {

    if (this.clmtlkSessionService.loggedInContact.CTC_SRC_CD === 'st') {

      if ( !this.clmtlkSessionService.userSignature && this.clmtlkSessionService.userSignature !== '' ) {
        this.clmtlkService.getStreamUserSignature()
          .subscribe(signature => {
              this.setSignature(signature, this.editor);
          },
          error => {
            this.toastrService.warning(` Failed to load user signature - ${error}`, 'Unsuccess' );
          }
        );
      }
    }
  }

  ngAfterViewInit() {
    const messageEditorComponent = this;

    tinymce.init({
      selector: '#' + this.elementId,
      plugins: ['link', 'paste', 'table', 'textcolor', 'colorpicker'],
      browser_spellcheck: true,
      skin_url: '../assets/skins/lightgray',
      branding: false,
      elementpath: false,
      statusbar: false,
      height: 250,
      init_instance_callback : editor => {
        if (messageEditorComponent.clmtlkSessionService.userSignature != null) {
            messageEditorComponent.setSignature(messageEditorComponent.clmtlkSessionService.userSignature,
            messageEditorComponent.editor);
        }
      }, 
      setup: editor => {
        this.editor = editor;
        editor.on('keyup', () => {
          this.messageContent = editor.getContent();
          this.onModelChange(this.messageContent);
        });

      editor.on('blur', () => {
          this.messageContent = editor.getContent();
          this.onModelChange(this.messageContent);
          this.onModelTouch();
        });
      }
    });

  }

  ngOnDestroy() {
    tinymce.remove(this.editor);
  }


  writeValue(obj: any): void {
    this.messageContent = <string>obj;
  }
  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onModelTouch = fn;
  }
  setDisabledState(isDisabled: boolean): void {
  }


  setSignature(signature: string, editor): void {

    if (!this.streamUserSignature || this.streamUserSignature === null) {
        this.streamUserSignature = (signature !== null) ?
        ('<p>&nbsp;</p><p>&nbsp;</p>' + signature.replace('<![CDATA[', '').replace(']]>', '')) : null;
    }

      if (this.streamUserSignature && this.streamUserSignature !== null && signature !== '' &&
        editor && editor !== null) {
          editor.setContent(this.streamUserSignature);
      }
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/new-message/message-form/message-editor/message-editor.component.ts